import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1410 - Fixed Income Linked
 */
export const config1410: ProductTypeConfig = {
  code: '1410',
  name: 'Fixed Income Linked',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false, // Moved to Coupon Details widget
        issuePrice: false,
        settlementType: true, // Settlement Type
        grade: true, // Grade
        recovery: true, // Recovery
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false, // No barrier section
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      enabled: false, // No underlyings - only price displayed
    },

    coupons: {
      enabled: true, // Coupon schedule table
      props: {
        showExDate: false, // No ex date for this product type
      },
    },

    couponDetails: {
      enabled: true, // Coupon details widget
      props: {},
    },

    earlyRedemption: {
      enabled: false, // No early redemption
      props: {},
    },

    performance: {
      enabled: true, // Only price chart
      props: {
        showUnderlyingsInChart: false, // No underlyings en el chart
        showTooltipPrice: false,
      },
    },
  },
};
